export {default} from './TipCheckout';
